import DOMPurify from "dompurify";

const ReceiptPopUp = ({popUpState, setPopUpState, curData}) => {

  const sanitizer = DOMPurify.sanitize;

  const onJSON = (value) => {
    try {
      return Object.entries(JSON.parse(value))
    }
    catch {
      return []
    }
  }

  const textCheck = (text) => {

    const type = text.split('_', 1)[0]
    const engText = text.split(`${type}_`)[1]
    let koText;

    switch (engText) {
      case 'use' :
      case 'menu_use' : koText = '사용여부'; break;
      case 'title' : koText = '제목'; break;
      case 'content' : koText = '내용'; break;
      case 'res_content' : koText = '답변 내용'; break;
      case 'category' :
      case 'cat' :
      case 'group' : koText = '카테고리'; break;
      case 'tag' : koText = '태그'; break;
      case 'res' : koText = '답변자'; break;
      case 'create_user' : koText = '작성자'; break;
      case 'email' :
        if(type === 'reqcat') {
          koText = '담당자 이메일';
        } else if (type === 'cust') {
          koText = '이메일 아이디';
        }
        break;
      case 'last_modify_user' : koText = '마지막 수정자'; break;
      case 'tel' : koText = '휴대폰 번호'; break;
      case 'corp' : koText = '업체명'; break;
      case 'name' : koText = '이름'; break;
      case 'pass' : koText = '비밀번호'; break;
    }
    return koText
  }

  
  return (
    // 요청 유형 팝업
    <div className={`${popUpState ? 'show' : ''} modal`}>
      <div className="modalBox">
        <div className="modalHeader">
          <h2>요청 유형</h2>
        </div>

        <div className="modalBody">
          <h2 className="modalBodyTit center">- {curData?.approve_req_cat}</h2>
          
          <div className="modalInfo">
            {onJSON(curData?.approve_api_view_param).map((data, i) =>
              <div key={i} className="modalItm">
                <h2>{textCheck(data[0])}</h2>
                <p dangerouslySetInnerHTML={{ __html: sanitizer(`${data[1]}`)}}></p>
              </div>
            )}
          </div>
        </div>

        <div className="modalFoot full">
          <button type="button" className="btn sm round_10 sfrtBlue" onClick={() => setPopUpState(!popUpState)}>닫기</button>
        </div>
      </div>
    </div>
  )
}

export default ReceiptPopUp